import React from 'react';
import { SupportBlock } from '../supportBlock/SupportBlock';

const AskForADeal = ({ shouldShowSalesLineNumber }: { shouldShowSalesLineNumber: boolean }) => {
  const blockVariant = 'default';
  const supportContactProps = {
    heading: 'ASK FOR A JB DEAL',
    subText: 'Seen it cheaper?',
    variant: 'narrow' as const,
    disclaimerText: window.Jbhifi.storeLocation === 'NZ' ? ' ' : 'Excludes JB Hi-Fi Marketplace Products',
  };
  return (
    <SupportBlock shouldShowSalesLineNumber={shouldShowSalesLineNumber} supportContactProps={supportContactProps} />
  );
};

export default AskForADeal;
